import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        ownerProfessionDetails: this.formBuilder.array(
          entity?.parameters?.ownerProfessionDetails &&
            entity?.parameters?.ownerProfessionDetails.length
            ? entity?.parameters?.ownerProfessionDetails.map(
                ownerProfessionDetail =>
                  this.formBuilder.group({
                    ownerId: [
                      {
                        value: ownerProfessionDetail.ownerId || null,
                        disabled: true,
                      },
                    ],
                    socialRegime: [
                      ownerProfessionDetail.socialRegime || null,
                      Validators.required,
                    ],
                    professionalCategory: [
                      ownerProfessionDetail.professionalCategory || null,
                      Validators.required,
                    ],
                    professionalCategorySub: [
                      ownerProfessionDetail.professionalCategorySub || null,
                    ],
                  }),
              )
            : this.generateDefaultOwnerProfessionDetails(entity),
        ),
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generateDefaultOwnerProfessionDetails(
    entity: PledgeProductRead & { parameters: any },
  ) {
    const loan = entity?.parameters?.loan;
    const ownerIds: number[] =
      loan?.owners && loan.owners.length
        ? loan.owners.map((o: any) => o.ownerId)
        : loan?.ownerIds && loan.ownerIds.length
          ? loan.ownerIds
          : [];

    if (ownerIds.length) {
      return ownerIds.map(ownerId =>
        this.formBuilder.group({
          ownerId: [{ value: ownerId, disabled: true }],
          socialRegime: [null, Validators.required],
          professionalCategory: [null, Validators.required],
          professionalCategorySub: [null],
        }),
      );
    }

    return [];
  }

  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  extract() {
    return this.form.getRawValue().products;
  }
}
